import { IconClock } from '@sequencehq/core-components'
import { SimplePaymentPage } from 'modules/PaymentsApp/components/SimplePaymentPage'

export const InProgress = () => {
  return (
    <SimplePaymentPage
      icon={IconClock}
      iconColour="gray.70"
      header="Payment in progress"
      subheader="Your payment mandate has been set up and payment is being&nbsp;collected"
      nextSteps={[
        "You'll receive an email confirmation once the payment has cleared. No further action is needed."
      ]}
    />
  )
}
